import { render, staticRenderFns } from "./storeaddress-add.vue?vue&type=template&id=dff06bfe"
import script from "./storeaddress-add.vue?vue&type=script&lang=ts"
export * from "./storeaddress-add.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports